import {
  DEVICES_PAGINATED_FETCH_STARTED,
  DEVICES_PAGINATED_FETCH_SUCCEEDED,
  DEVICES_PAGINATED_FETCH_FAILED,
  DEVICES_PAGINATED_CHANGE_PAGE,
  DEVICES_PAGINATED_CHANGE_ITEMS_PER_PAGE,
  DEVICES_PAGINATED_CHANGE_ORDER,
  DEVICES_PAGINATED_CHANGE_ORDER_BY,
  DEVICES_PAGINATED_CHANGE_ORDER_AND_ORDER_BY,
  DEVICES_PAGINATED_SET_FILTER,
  DEVICES_PAGINATED_SET_ASSIGNED_STATUS,
  DEVICES_PAGINATED_CLEAR
} from '#action/types';
import { requestStatuses as statuses } from '#helper';

const defaultState = {
  status: statuses.idle,
  devices: [],
  error: null,
  page: 1,
  itemsPerPage: 50,
  order: 'desc',
  orderBy: 'event',
  pages: 0,
  filter: null,
  assignedStatus: 'all'
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case DEVICES_PAGINATED_FETCH_STARTED:
      return { ...state, status: statuses.loading, error: null };
    case DEVICES_PAGINATED_FETCH_SUCCEEDED:
      return {
        ...state,
        status: statuses.succeeded,
        devices: action.payload,
        pages: Math.ceil(action.totalCount / state.itemsPerPage),
        totalCount: action.totalCount
      };
    case DEVICES_PAGINATED_FETCH_FAILED:
      return { ...state, status: statuses.failed, devices: [], error: action.error };
    case DEVICES_PAGINATED_CHANGE_PAGE:
      return { ...state, page: action.payload };
    case DEVICES_PAGINATED_CHANGE_ITEMS_PER_PAGE:
      return { ...state, itemsPerPage: action.payload };
    case DEVICES_PAGINATED_CHANGE_ORDER:
      return { ...state, order: action.payload };
    case DEVICES_PAGINATED_CHANGE_ORDER_BY:
      return { ...state, orderBy: action.payload };
    case DEVICES_PAGINATED_CHANGE_ORDER_AND_ORDER_BY:
      return { ...state, order: action.payload.order, orderBy: action.payload.orderBy };
    case DEVICES_PAGINATED_SET_FILTER:
      return { ...state, filter: action.payload };
    case DEVICES_PAGINATED_SET_ASSIGNED_STATUS:
      return { ...state, assignedStatus: action.payload };
    case DEVICES_PAGINATED_CLEAR:
      return defaultState;
    default:
      return state;
  }
};
